import { useQuery } from "react-query";
import React, { memo } from "react";
import { fetchGetNewCarReleaseListData, fetchNewCarNav } from "@Services/api";
import CarItem from "../CarItem/Index";
import { INewCarNav } from "@Types/api";
import { useSetState } from "ahooks";

interface IProps {
  activityTitle?: string;
}

const NavList: React.FC<any> = ({ month, onClick }) => {
  const initData: INewCarNav["list"] = [];
  const { data = initData } = useQuery<INewCarNav["list"]>([`fetchNewCarNavInquiery`], async () => {
    const res = await fetchNewCarNav({ type: "inquiry" });
    if (res?.status === 12000) {
      onClick(res.data.list[0].month, res.data.list[0].year);
      return res.data.list;
    }
    return initData;
  });

  return (
    <div id={"NavList"} className='flex mb-20 items-center gap-24'>
      <p className='font-bold text-24 text-[#333]'>新車上市</p>
      <div className='flex items-center gap-10'>
        {data.map((item, index) => (
          <div
            onClick={() => onClick(item.month, item.year)}
            key={index}
            className={`cursor-pointer text-14 w-40 h-24 flex items-center justify-center rounded-4 ${month === item.month ? `text-white bg-[#3264FF]` : `text-black`
              } `}
          >
            {item.month}月
          </div>
        ))}
      </div>
    </div>
  );
};

const NewCarRelease = (props: IProps) => {
  const [params, setParams] = useSetState({
    month: "",
    year: "",
  });
  const { month, year } = params;
  const { data } = useQuery(
    `fetchGetNewCarReleaseListData${month}${year}`,
    async () => {
      const res = await fetchGetNewCarReleaseListData({ m: month, y: year, type: "inquiry", limit: 4 });
      return { list: res.data || [] };
    },
    { enabled: !!month, initialData: { list: [] } },
  );

  return (
    <section className={"h-[242px] w-full mx-auto relative"}>
      <NavList month={month} onClick={(month, year) => setParams({ month, year })} />
      <div className={"mt-20 grid gap-24 grid-cols-4 mb-40"}>
        {data?.list?.map((item, index) => (
          <React.Fragment key={index}>
            <CarItem
              dataObj={{
                kindId: item.kind_id,
                thumb: item.thumb,
                brandName: item.brandName,
                kindName: item.kindName,
                price: item.price,
                brandId: item.brand_id,
                picHref: item.link,
                // btnHref: `${host.c}/ask/price?b=${item.brandId}&k=${item.kindId}&source=找車-新車上市`,
                btnHref: "",
              }}
            />
          </React.Fragment>
        ))}
      </div>
    </section>
  );
};

export default memo(NewCarRelease);
